module.exports = __webpack_public_path__ + "img/ic_information@3x.adf6f22e.png";